import React from 'react';
import PropTypes from 'prop-types';

function ISTiktokV2({ to, className }) {
  return (
    <a className={className} target={`_blank`} rel="noopener noreferrer" href={to}>
      <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_8822_114011)">
          <path d="M13.3081 0.56488H10.1841V13.0528C10.1841 14.5407 8.98261 15.763 7.48738 15.763C5.99215 15.763 4.79063 14.5407 4.79063 13.0528C4.79063 11.5915 5.96545 10.3958 7.40729 10.3427V7.2074C4.22992 7.26052 1.66669 9.83783 1.66669 13.0528C1.66669 16.2944 4.28332 18.8982 7.51409 18.8982C10.7448 18.8982 13.3614 16.2678 13.3614 13.0528V6.64941C14.5363 7.49967 15.9781 8.0045 17.5 8.03108V4.8958C15.1504 4.81609 13.3081 2.90304 13.3081 0.56488Z" fill="#5A5A5A"/>
        </g>
        <defs>
          <clipPath id="clip0_8822_114011">
            <rect width="20" height="20" fill="white" transform="translate(0 0.56488)"/>
          </clipPath>
        </defs>
      </svg>
    </a>
  )
}


ISTiktokV2.propTypes = {
  to: PropTypes.string.isRequired,
  className: PropTypes.string,
}

export default ISTiktokV2;
